import React from 'react'
import { find } from 'lodash'
import Checkbox from '../../Checkbox/Checkbox'
import { Option, Button } from './index.style'

const OptionRenderer = ({
  selectedVerticals,
  selectOnlyOneOption,
  ...option
}) => {
  const isChecked = !!find(
    selectedVerticals,
    vertical => vertical.id === option.id
  )

  const onClick = () => selectOnlyOneOption(option)

  return (
    <Option>
      <Checkbox label={option.name} isChecked={isChecked} />
      <Button type="button" onClick={onClick}>
        Only
      </Button>
    </Option>
  )
}

export default OptionRenderer



// WEBPACK FOOTER //
// ./src/components/PollForm/VerticalTargeting/OptionRenderer.js